(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-customer-strip"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-mc-review-slider]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-mc-review-track]');
    const cards = Array.from(track.children);
    if (cards.length < 2) return;
    const controls = root.querySelector('[data-mc-review-controls]');
    controls.hidden = false;
    const pause = root.querySelector('[data-mc-review-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, timer, stopped = reduced.matches, hovered = false;
    const render = () => { pause.textContent = stopped ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', stopped ? pause.dataset.playLabel : pause.dataset.pauseLabel); };
    const move = direction => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      if (direction > 0 && track.scrollLeft >= maximum - 8) index = 0;
      else if (direction < 0 && track.scrollLeft <= 8) index = cards.length - 1;
      else index = Math.max(0, Math.min(cards.length - 1, index + direction));
      track.scrollTo({left: Math.min(maximum, cards[index].offsetLeft - cards[0].offsetLeft), behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    const restart = () => {
      clearInterval(timer);
      if (!stopped && !hovered && !document.hidden && !root.contains(document.activeElement)) timer = setInterval(() => { if (!root.isConnected) clearInterval(timer); else move(1); }, 4500);
    };
    root.querySelector('[data-mc-review-prev]').addEventListener('click', () => move(-1));
    root.querySelector('[data-mc-review-next]').addEventListener('click', () => move(1));
    pause.addEventListener('click', () => { stopped = !stopped; render(); restart(); });
    root.addEventListener('mouseenter', () => { hovered = true; restart(); });
    root.addEventListener('mouseleave', () => { hovered = false; restart(); });
    root.addEventListener('focusin', restart);
    root.addEventListener('focusout', () => requestAnimationFrame(restart));
    document.addEventListener('visibilitychange', restart);
    reduced.addEventListener('change', () => { stopped = reduced.matches; render(); restart(); });
    track.addEventListener('scroll', () => { index = cards.reduce((closest, card, i) => Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) < Math.abs(cards[closest].offsetLeft - cards[0].offsetLeft - track.scrollLeft) ? i : closest, 0); });
    render(); restart();
  });
  initialize(); document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-header"]) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
    const timers = new WeakMap();
    const initialize = () => document.querySelectorAll('.mc-header__nav .mc-platform-menu, .mc-mobile-menu').forEach(menu => {
      if (menu.dataset.hoverReady) return;
      menu.dataset.hoverReady = 'true';
      menu.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clearTimeout(timers.get(menu));
        document.querySelectorAll('.mc-header__nav .mc-platform-menu[open], .mc-mobile-menu[open]').forEach(other => {
          if (other !== menu) other.open = false;
        });
        menu.open = true;
      });
      menu.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;
        timers.set(menu, setTimeout(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }, 140));
      });
      menu.addEventListener('focusout', () => setTimeout(() => {
        if (!menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;
      }, 0));
    });
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mc-mobile-menu nav a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mc-platform-menu[open]').forEach((menu) => {menu.open=false;menu.querySelector('summary').focus()});
    document.querySelectorAll('.mc-mobile-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
